import * as React from "react";
import Component from "../../AbstractComponent";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import Translator from "../../../Translation/Translator";
import { TableComponent } from "../Table/TableComponent";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from "../../Partials/Material/TextField";
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';

export default class Charges2List extends Component {
	protected searchTimer;

	public state = {
		directIndirectCharges: [],
		selectedDirectIndirectChargesRows: [],
		objectCharges: [],
		selectedObjectChargesRows: [],
		showDirectIndirectChargesList: false,
		chargeSearchString: "", 
		chargeSearchInProgress: false
	};

  constructor(public props) {
    super(props);
	}

	public componentWillMount() {
		this.setState({
			directIndirectCharges: this.props.directIndirectCharges || [],
			selectedDirectIndirectChargesRows: this.props.selectedDirectIndirectChargesRows || [],
			objectCharges: this.props.objectCharges || [],
			selectedObjectChargesRows: this.props.selectedObjectChargesRows || [],
			showDirectIndirectChargesList: !!this.props.directIndirectCharges && this.props.directIndirectCharges.length > 0,
			// chargeSearchString: this.props.chargeSearchString,
			chargeSearchInProgress: this.props.chargeSearchInProgress,
		});
	}

	public componentWillReceiveProps(nextProps) {
		if (JSON.stringify(this.state.directIndirectCharges) !== JSON.stringify(nextProps.directIndirectCharges)) {
			this.setState({
				showDirectIndirectChargesList: !!nextProps.directIndirectCharges &&
																			 nextProps.directIndirectCharges.length > 0
			});
		}
		this.setState({
			directIndirectCharges: nextProps.directIndirectCharges || [],
			selectedDirectIndirectChargesRows: nextProps.selectedDirectIndirectChargesRows || [],
			objectCharges: nextProps.objectCharges || [],
			selectedObjectChargesRows: nextProps.selectedObjectChargesRows || [],
			// chargeSearchString: nextProps.chargeSearchString,
			chargeSearchInProgress: nextProps.chargeSearchInProgress,
		});
	}

	public componentWillUnmount() {
    this.clearTimer();
  }

	public clearTimer = () => {
		clearTimeout(this.searchTimer);
		this.searchTimer = null;
	}

	public getCharges = (charges: ChargeInterface[], selectedChargesRows: number[], callback: any): any => {
		if(typeof this.props.getCharges === "function") {
			return this.props.getCharges.call(this, charges, selectedChargesRows, callback);
		}
	}

	public onDirectInDirectChargeRowSelection = (event, rows: number[]): void => {
		if(typeof this.props.onDirectInDirectChargeRowSelection === "function") {
			return this.props.onDirectInDirectChargeRowSelection.call(this, event, rows);
		}
	}

	public onObjectChargeRowSelection = (event, rows: number[]): void => {
		if(typeof this.props.onObjectChargeRowSelection === "function") {
			return this.props.onObjectChargeRowSelection.call(this, event, rows);
		}
	}

	public onFilteredChargeRowSelection = (event, rows: number[]): void => {
		if(typeof this.props.onFilteredChargeRowSelection === "function") {
			return this.props.onFilteredChargeRowSelection.call(this, event, rows);
		}
	}

	public switchListView = (): void => {
		this.setState({
			showDirectIndirectChargesList: !this.state.showDirectIndirectChargesList
		})
	}

	public setSearchString = (event): any => {
    this.clearTimer();

    this.setState({
      chargeSearchString: event.target.value
    }, () => {
      if (this.state.chargeSearchString === "") {
        this.clearSearchString();
      }

      this.searchTimer = setTimeout(() => {
        if (typeof this.props.updateChargeSearchString === "function") {
			this.props.updateChargeSearchString(this.state.chargeSearchString);
		}
      }, this.props.app?.listSearchTimeout);
    });
  }

	public clearSearchString = () => {
		this.clearTimer();

    this.setState({
      chargeSearchString: ""
    }, () => {
			if (typeof this.props.updateChargeSearchString === "function") {
				this.props.updateChargeSearchString(this.state.chargeSearchString);
			}
		});
  }

  public render() {
		const exsistingDirectIndirectChargesAmount: number =
			this.state.directIndirectCharges.map((charge: ChargeInterface, index: number) => {
				if (this.state.selectedDirectIndirectChargesRows.includes(index)) {
					const amountUnpaid = charge?.amountRemaining;

					return amountUnpaid;
				}

				return 0;
			}).reduce((a, b) => a + b, 0);

		const exsistingObjectChargesAmount: number =
			this.state.objectCharges && this.state.objectCharges.map((charge: ChargeInterface, index: number) => {
				if (this.state.selectedObjectChargesRows.includes(index)) {
					const amountUnpaid = charge?.amountRemaining;

					return amountUnpaid;
				}

				return 0;
			}).reduce((a, b) => a + b, 0);

    return (
			<Card 
				className="card"
				style={{
					marginBottom: "20px"
				}}
			>
				<div style={{
					padding: "0 0 20px 10px",
					paddingTop: this.props.hideHeader ? "10px" : "0"
					}}>
					{
						!this.props.hideHeader && !this.props.isSettleProcess && this.props.directIndirectCharges?.length === 0 && 
						<div style={{padding: "10px 24px 5px 0"}}>{this.trans("page/paymentupdate-hint/paymenthasnotmatchingcharges")}</div>
					}

					{
						!this.props.hideHeader && !this.props.isSettleProcess && this.props.directIndirectCharges?.length > 0 && 
						<div style={{padding: "10px 24px 5px 0"}}>{this.trans("page/paymentupdate-hint/paymenthasmatchingcharges")}</div>
					}

					{
						!this.props.hideHeader && this.props.isSettleProcess && 
						<div style={{padding: "10px 24px 5px 0"}}>{this.trans("coach/settlecharge-step/first-info")}</div>
					}

					<div>
						<div>
							{
								!this.props.hideSwitcher && this.state.directIndirectCharges && this.state.directIndirectCharges.length > 0 &&
									<div
										style={{display: "flex"}}
									>
										<FormControlLabel
											control={
												<Switch
													checked={this.state.showDirectIndirectChargesList}
													onChange={this.switchListView}
													color="primary"
												/>
												}
											label={this.trans("section/charge-tab/existing-switch/listswitcher-label")}
										/>
									</div>
							}

							{
								this.state.showDirectIndirectChargesList && (
									<div style={{marginTop: "20px"}}>
										{
											!this.props.hideTotalAmount && this.state.directIndirectCharges && this.state.directIndirectCharges.length > 0 && (
												<div
													style={{
														padding: "0 24px 15px 0",
														fontSize: "14px",
														display: "flex",
														justifyContent: "flex-end",
														textAlign: "center"
													}}
												>
													{Translator.transJSX("total-amount", {
														amount: <span style={{fontWeight: "bold"}}>{this.formatter.formatNumber(exsistingDirectIndirectChargesAmount, this.props.app.settings.user.currency)}</span>
													})}
												</div>
											)
										}
										
										<TableComponent
											{...this.props}
											paginator={{
												name: "ExsistingDirectIndirectChargesList",
												path: this.props.app.paginator
											}}
											className="listing-table new-payment-charges-table"
											rows={this.getCharges(this.state.directIndirectCharges,
																						this.state.selectedDirectIndirectChargesRows,
																						this.onDirectInDirectChargeRowSelection)
														}
										/>
										{this.state.directIndirectCharges?.length === 0 && (
											<div style={{padding: "0 25px 0 0", color: "gray"}}>{this.trans("section/charge-tab/existing-info/chargesnotfound")}</div>
										)}
										<div style={{width: "100%", display: "flex", justifyContent: "flex-start"}}>
											{this.props.saveButton}
										</div>
									</div>
								)
							}

							{
								!this.state.showDirectIndirectChargesList && (
									<div>
										<div className="list-filterer">
											<TextField
												className="form-element full-size"
												autoComplete="off"
												type="text"
												style={{color: "rgb(0, 188, 212)"}}
												label={this.trans("label/searchcharge")}
												value={this.state.chargeSearchString}
												onChange={this.setSearchString}
												variant="standard"
												error={false}
											/>
											{ 
												this.state.chargeSearchString !== "" &&
												<div className="icon icon-ic-close clear-button clear-button-search" onClick={this.clearSearchString}></div>
											}
											{ 
												this.state.chargeSearchInProgress &&
												<div className="search-loader">
													<CircularProgress size={20} />
												</div>
											}
										</div>

										<div style={{marginTop: "20px"}}>
											{
												!this.props.hideTotalAmount && this.state.objectCharges && this.state.objectCharges.length > 0 && (
													<div
														style={{
															padding: "0 24px 15px 0",
															fontSize: "14px",
															display: "flex",
															justifyContent: "flex-end",
															textAlign: "center",
															paddingTop: this.props.hideHeader ? "15px" : "0"
														}}
													>
														{Translator.transJSX("total-amount", {
															amount: <span style={{fontWeight: "bold"}}>{this.formatter.formatNumber(exsistingObjectChargesAmount, this.props.app.settings.user.currency)}</span>
														})}
													</div>
												)
											}
											<TableComponent
												{...this.props}
												paginator={{
													name: "ExsistingObjectChargesList",
													path: this.props.app.paginator
												}}
												dispatch={this.props.dispatch}
												className="listing-table new-payment-charges-table"
												rows={this.getCharges(this.state.objectCharges, this.state.selectedObjectChargesRows, this.onObjectChargeRowSelection)}
											/>
											{this.searchTimer && this.state.chargeSearchString && !this.state.chargeSearchInProgress && this.state.objectCharges?.length === 0 && (
												<div style={{padding: "0 25px 0 0", color: "gray"}}>{this.trans("section/charge-tab/existing-info/chargesnotfound")}</div>
											)}
											<div style={{width: "100%", display: "flex", justifyContent: "flex-start"}}>
												{this.props.saveButton}
											</div>
										</div>
									</div>
								)
							}
						</div>
					</div>
				</div>
			</Card>
    );
  }
}
